export const jobCreationSteps = {
  admin: {
    id: 0,
    ui: 'Choose Employer and Event'
  },
  first: {
    id: 1,
    ui: 'Step 1 of 3 - Position'
  },
  second: {
    id: 2,
    ui: 'Step 2 of 3 - Where and When'
  },
  third: {
    id: 3,
    ui: 'Step 3 of 3 - Dress Code and Instructions'
  },
  summary: {
    id: 4,
    ui: ''
  }
};

export const employerJobCreationStepsSingle = {
  first: {
    id: 1,
    ui: 'Step 1 of 3 - Job Location'
  },
  second: {
    id: 2,
    ui: 'Step 2 of 3 - Skill and Quantity Needed'
  },
  third: {
    id: 3,
    ui: 'Step 3 of 3 - Dress Code and Additional Instructions'
  },
  summary: {
    id: 4,
    ui: ''
  }
};

export const jobWorkerStatuses = [
  { id: 'matched', value: 'Matched' }, // When Gravy backend suggests a candidate
  { id: 'offered', value: 'Offered' }, // Employer invites worker
  { id: 'rejected', value: 'Cancelled' }, // Employer passes on worker
  { id: 'hired', value: 'Hired' }, // When worker is offered job and accepts
  { id: 'declined', value: 'Declined' }, // When worker is offered job and passes
  { id: 'worker_cancelled', value: 'Dropped' }, // When worker cancels the job after accepting job
  { id: 'worker_cancelled_consequence', value: 'Dropped < 24 Hrs' }, // When worker cancels the job after accepting job and it's too close to job start_date
  { id: 'job_cancelled', value: 'Job cancelled' }, // When employer cancels the job after worker is hired
  { id: 'worker_no_show', value: 'No Show' } // When worker haven't appeared to work
];

export const jobWorkerStatusesFilter = ['offered', 'hired', 'worker_cancelled', 'worker_no_show', 'rejected'];

export const jobWorkerStatus = {
  MATCHED: 'matched', // When Gravy backend suggests a candidate
  OFFERED: 'offered', // Employer invites worker
  REJECTED: 'rejected', // Employer passes on worker
  HIRED: 'hired', // When worker is offered job and accepts
  DECLINED: 'declined', // When worker is offered job and passes
  WORKER_CANCELLED: 'worker_cancelled', // When worker cancels the job after accepting job
  WORKER_CANCELLED_CONSEQUENCE: 'worker_cancelled_consequence', // When worker cancels the job after accepting job and it's too close to job start_date
  JOB_CANCELLED: 'job_cancelled', // When empl cancels the job after worker is hired,
  WORKER_NO_SHOW: 'worker_no_show' // When worker haven't appeared to work
};

export const jobWorkerStatusSortingIndexes = {
  hired: 0,
  offered: 1,
  matched: 2,
  worker_cancelled: 3,
  worker_cancelled_consequence: 4,
  job_cancelled: 5,
  declined: 6,
  rejected: 7,
  worker_no_show: 8
};

export const workerActualMinutesValues = [
  {
    label: '00',
    value: 0
  },
  {
    label: '15',
    value: 25
  },
  {
    label: '30',
    value: 50
  },
  {
    label: '45',
    value: 75
  }
];

export const workerBreakMinutesValues = [
  {
    label: '0m',
    value: 0,
    id: 0
  },
  {
    label: '15m',
    value: 15,
    id: 1
  },
  {
    label: '30m',
    value: 30,
    id: 2
  },
  {
    label: '45m',
    value: 45,
    id: 3
  },
  {
    label: '1h',
    value: 60,
    id: 4
  },
  {
    label: '1h 15m',
    value: 75,
    id: 5
  },
  {
    label: '1h 30m',
    value: 90,
    id: 6
  },
  {
    label: '1h 45m',
    value: 105,
    id: 7
  },
  {
    label: '2h',
    value: 120,
    id: 8
  },
  {
    label: '2h 15m',
    value: 135,
    id: 9
  },
  {
    label: '2h 30m',
    value: 150,
    id: 10
  },
  {
    label: '2h 45m',
    value: 165,
    id: 11
  },
  {
    label: '3h',
    value: 180,
    id: 12
  }
];

export const workerSentHomeReasons = {
  notNeeded: 'I wasn’t needed',
  wasLate: 'I showed up late',
  noUniform: 'I wasn’t wearing the proper uniform',
  other: 'Other'
};

export const jobStatuses = {
  saved: {
    server: 'saved',
    ui: 'Draft'
  },
  posted: {
    server: 'posted',
    ui: 'Unfilled'
  },
  filled: {
    server: 'filled',
    ui: 'Filled'
  },
  cancelled: {
    server: 'cancelled',
    ui: 'Cancelled'
  },
  completed: {
    server: 'completed',
    ui: 'Completed'
  },
  deleted: {
    server: 'deleted',
    ui: 'Deleted'
  }
};

export const minJobHoursValue = 4;

export const jobDurationMinuteInterval = 15;

/**
 * @description Representation of minJobHoursValue in minutes
 * @type {number}
 */
export const minJobMinutesValue = minJobHoursValue * 60;

export const maxWorkingHoursValue = 23.75;

/**
 * @description Representation of maxWorkingHoursValue in minutes 23.75 * 60 = 1425 min
 * @type {number}
 */
export const maxWorkingMinutesValue = maxWorkingHoursValue * 60;

export const maxWorkingHoursUi = '23 hours 45 min';

export const jobsListPeriods = {
  current: {
    id: 'current',
    ui: 'Current Jobs'
  },
  past: {
    id: 'past',
    ui: 'Past Jobs'
  }
};

export const daysDiffForMultipleJobs = 6; // max range between first and last job for multiple jobs is 7 days

export const prevMonthNavLabel = 'PREV'; // Don't change this constants.
export const nextMonthNavLabel = 'NEXT'; // They are handled by react-big-calendar

export const minWorkersAmountToShowFilter = 5;

export const jobWorkerHoursNeedApproval = 8;

export const ratingMinimum = 1;

export const ratingMaximum = 5;

export const tipTaxAmount = 18.76;

export const privatePartyJobCategoryType = 'private_party';
export const privatePartyJobCategoryTitle = 'Private Party';



// WEBPACK FOOTER //
// ./src/constants/jobs.js